module.exports = __webpack_public_path__ + "static/img/bank12-1.fc9763d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bank/bank12-1.png
// module id = k06h
// module chunks = 1